import JsBarcode from "jsbarcode";

/**
 * 文本转条形码
 *
 * 返回base64字符串形式的png图片链接
 */
export default function textToBarCodeBase64(text: string, height: number) {
    try {
        const canvas = document.createElement("canvas");

        JsBarcode(canvas, text, {
            format: "CODE128",
            height,
        });

        const dataURL = canvas.toDataURL("image/png");

        return dataURL;
    } catch (error) {
        console.error("解析textToBarCodeBase64出现异常:", error, error?.message);
    }

    return "";
}
